module.exports = __webpack_public_path__ + "static/assets/c6ab79fc9e76cb500fc83b6f1c6437d0.png";